import useSWR from 'swr';
import { fetcher } from '../../../services/fetcher';
import type { StatusTextColorMode } from '../../../utils/statusColor';

// API endpoints
const API_LIST = '/p-crm-task-status';
const API_DETAIL = (id: number) => `/p-crm-task-status/${id}`;

export interface TaskStatus {
  id: number;
  ts_descr?: string;
  ts_color?: string;
}

export const useTaskStatuss = (searchParams?: string) => {
  const queryString = searchParams ? `?searchParams=${encodeURIComponent(searchParams)}` : '';
  const { data, error, isLoading, mutate } = useSWR<TaskStatus[]>(
    `${API_LIST}${queryString}`,
    fetcher,
    {
      revalidateOnFocus: true,
      revalidateOnReconnect: true,
    }
  );

  return {
    data: data || [],
    taskStatuss: data || [],
    isLoading,
    isError: error,
    mutate,
  };
};

export const useTaskStatus = (id: number) => {
  const { data, error, isLoading, mutate } = useSWR<TaskStatus>(
    id ? API_DETAIL(id) : null,
    fetcher,
    {
      revalidateOnFocus: true,
    }
  );

  return {
    data: data,
    taskStatus: data,
    isLoading,
    isError: error,
    mutate,
  };
};
